import { TariffLineItemData } from "../TariffLineItemData";
import { Button, Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffManagementTLIAdjustRates extends Layout {
    buttonApply: Button;
    buttonClear: Button;
    checkboxAdjustMax: Checkbox;
    checkboxAdjustMin: Checkbox;
    checkboxAdjustRates: Checkbox;
    labelExpireTariffLineItems: Label;
    labelFailure: Label;
    labelInfo: Label;
    labelMainTariffLineItemDetails: Label;
    labelNewTariffLineItems: Label;
    labelPercentageRatesBy: Label;
    labelPercentageRatesMax: Label;
    labelPercentageRatesMin: Label;
    layoutTariffLineItemDataActive: TariffLineItemData;
    layoutTariffLineItemDataExpire: TariffLineItemData;
    panelTLIAdjustRates: Panel;
    panelTableHeader: Panel;
    sourceTariffLineItem: DataSource;
    textboxAdjustRateBy: Textbox;
    textboxAdjustRateByValue: Textbox;
    textboxAdjustRateMax: Textbox;
    textboxAdjustRateMaxValue: Textbox;
    textboxAdjustRateMin: Textbox;
    textboxAdjustRateMinValue: Textbox;
    textboxEffectiveDate: Textbox;
    textboxMethodValue: Textbox;
}
